import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface PageHeroProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  crumbs: Crumb[];
}

export default function PageHero({ eyebrow, title, subtitle, crumbs }: PageHeroProps) {
  return (
    <section className="bg-primary-950 text-background-50 pt-28 md:pt-36 pb-14 md:pb-20">
      <div className="w-full px-4 md:px-8">
        <nav aria-label="面包屑" className="mb-6">
          <ol className="flex flex-wrap items-center gap-2 text-xs text-background-300">
            {crumbs.map((crumb, index) => (
              <li key={crumb.label} className="flex items-center gap-2">
                {index > 0 && <i className="ri-arrow-right-s-line" aria-hidden="true"></i>}
                {crumb.to ? (
                  <Link to={crumb.to} className="hover:text-accent-300 transition-colors">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-background-100">{crumb.label}</span>
                )}
              </li>
            ))}
          </ol>
        </nav>

        <p className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-accent-300 mb-4">
          <span className="w-6 h-px bg-accent-400 inline-block"></span>
          {eyebrow}
        </p>
        <h1 className="font-heading font-bold text-3xl md:text-5xl leading-tight max-w-3xl">{title}</h1>
        <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200 max-w-2xl">{subtitle}</p>
      </div>
    </section>
  );
}